import { ContainerModule } from "inversify";
import {
  PesquisaDrawerGateway,
  PesquisaDrawerGatewayDi
} from "../services/ports/PesquisaDrawerGateway";
import { PesquisaDrawerGatewayAdapter } from "../services/adaptors/PesquisaDrawerGatewayAdapter";

const pesquisaDrawerContainer = new ContainerModule((bind) => {
  bind<PesquisaDrawerGateway>(PesquisaDrawerGatewayDi).to(
    PesquisaDrawerGatewayAdapter
  );
});

export { pesquisaDrawerContainer };
